
import { Vue, Component } from "vue-property-decorator";
import I18nDropdown from "@/components/i18nDropdown.vue";
import { dispatchLogOut } from "@/store/main/actions";
import { commitSetOutsideHeaderMobileMenuOpen } from "@/store/main/mutations";
import {
  readOutsideHeaderMobileMenuOpen,
  readUserProfile,
} from "@/store/main/getters";
import {formatBalance} from "@/utils";
import {USER_ROLES} from '@/constants';
@Component({
  methods: { formatBalance },
  components: {
    I18nDropdown,
  },
})
export default class Header extends Vue {
  public showMobWallets: boolean = false;
  public showDexnetInfo: boolean = false;
  public showDexnetNumbers: boolean = false;
  public showUSDTNumbers: boolean = false;
  // public showMobileInfo: boolean = false;
  public ignored = ['NavigationDuplicated', 'NavigationCancelled'];
  
  public handleChangePath(path:string) {
    // this.$router.push(path);
    this.$router.push(path).catch((err) => {
      if (!this.ignored.includes(err.name)) {
        throw err;
      }
    });
  }

  public get isResidentRole() {
    const role = this.userProfile?.role;
    return role === USER_ROLES.RESIDENT || role === USER_ROLES.RESIDENT_LIMITED;
  }

  public openMobileMenu() {
    commitSetOutsideHeaderMobileMenuOpen(this.$store, true);
    this.showMobWallets = false;
  }

  public closeMobileMenu() {
    commitSetOutsideHeaderMobileMenuOpen(this.$store, false);
    this.showMobWallets = false;
  }

  public async handleLogOut() {
    await dispatchLogOut(this.$store);
  }

  get isMobileMenuOpen() {
    return readOutsideHeaderMobileMenuOpen(this.$store);
  }
  get userProfile() {
    return readUserProfile(this.$store);
  }
  get currentPath() {
    return this.$route.path;
  }
}
